import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import cognito from './aws/cognito';
import dynamodb from './aws/dynamodb';
import s3 from './aws/s3';
import lambda from './aws/lambda';

const awsUtils = {
  mixins: [guid, lambda],
  data() {
    return {
      globalUploadProgress: null,
      globalFileInProgress: null,
    };
  },
  computed: {
    ...mapGetters([
      'account',
      'userPool',
      'identityId',
      'currentUser',
      'priceSource',
    ]),
    _customerFolder() {
      // this always needs to be the owner's folder
      const subUser = this.currentUser.subuser;
      const ownerId = subUser ? subUser.owner._id : this.identityId;
      const { owner = {} } = this._currentSite;
      return `uuid-${owner._id || ownerId}`;
    },
    _uploadFolder() {
      // this will always be the currentUser's folder
      return `uuid-${this.identityId}`;
    },
    _sitePath() {
      return `sites/${this._currentSite.name}`;
    },
    _fullSiteFolder() {
      return `${this._customerFolder}/${this._sitePath}`;
    },
    _currentSite() {
      // we need to get the correct site bucket for current site
      return this.$store.getters.currentSite;
    },
    _currentPage() {
      // we need to get the correct site bucket for current site
      return this.$store.getters.currentPage;
    },
    _limits() {
      return this._checkLimits();
    },
  },
  methods: {
    ...cognito,
    ...dynamodb,
    ...s3,
    _checkLimits(website) {
      const site = website || this._currentSite;
      const defaults = {
        reached: false,
      };
      const pages = _.clone(defaults);
      const drafts = _.clone(defaults);
      const templates = _.clone(defaults);
      const forms = _.clone(defaults);
      const recycled = _.clone(defaults);
      const domains = _.clone(defaults);
      const dynamics = _.clone(defaults);

      // if site is fully published do the limit check, if not
      // that means it's in a limitless build state and we need to
      // allow anything
      if (!this._published) {
        return {
          pages,
          drafts,
          templates,
          forms,
          recycled,
          domains,
          dynamics,
        };
      }

      if (site && site.tier === 'Free') {
        const limits = this.priceSource.tiers.Free.limits;
        const allDynamics = this._allDynamicItems(site);
        if (!website) {
          pages.reached = site.pages.length >= limits.pages;
          drafts.reached = site.drafts.length >= limits.drafts;
          templates.reached = site.templates.length >= limits.templates;
          forms.reached = site.forms && site.forms.length >= limits.forms;
          recycled.reached = site.recycled && site.recycled.length >= limits.recycled;
          domains.reached = site.domains.length >= limits.domains;
          dynamics.reached = allDynamics.length >= limits.dynamics;
        } else if (website) {
          pages.reached = site.pages.length > limits.pages;
          drafts.reached = site.drafts.length > limits.drafts;
          templates.reached = site.templates.length > limits.templates;
          forms.reached = site.forms && site.forms.length > limits.forms;
          recycled.reached = site.recycled && site.recycled.length > limits.recycled;
          domains.reached = site.domains.length > limits.domains;
          dynamics.reached = allDynamics.length > limits.dynamics;
        }
      }
      if (site && site.tier === 'Starter') {
        const limits = this.priceSource.tiers.Starter.limits;
        if (!website) {
          pages.reached = site.pages.length >= limits.pages;
          drafts.reached = site.drafts.length >= limits.drafts;
          templates.reached = site.templates.length >= limits.templates;
          forms.reached = site.forms && site.forms.length >= limits.forms;
          recycled.reached = site.recycled && site.recycled.length >= limits.recycled;
          domains.reached = site.domains.length >= limits.domains;
        } else if (website) {
          pages.reached = site.pages.length > limits.pages;
          drafts.reached = site.drafts.length > limits.drafts;
          templates.reached = site.templates.length > limits.templates;
          forms.reached = site.forms && site.forms.length > limits.forms;
          recycled.reached = site.recycled && site.recycled.length > limits.recycled;
          domains.reached = site.domains.length > limits.domains;
        }
      }

      return {
        pages,
        drafts,
        templates,
        forms,
        recycled,
        domains,
        dynamics,
      };
    },
    _allDynamicItems(site) {
      let totals = [];
      if (site.dynamic) {
        const types = Object.keys(site.dynamic);
        for (let key = 0; key < types.length; key++) {
          const type = site.dynamic[types[key]];
          totals = totals.concat([...type.items, ...type.published]);
        }
      }
      return totals;
    },
  },
};

export { awsUtils };



// WEBPACK FOOTER //
// ./src/mixins/aws-utils.js